import { mockUserRegistryItems, mockUserRegistrySummary } from '@/__mocks__';

const userRegistryApi = {
  requestList() {
    return new Promise((resolve) => {
      const users = 10;
      setTimeout(() => {
        const items = {
          data: {
            users: mockUserRegistryItems(users),
            paging: {
              next_cursor: 'MjAyMS0wOC0wMVQxNToyNTo0OS4zODg3MjNa',
              next_link:
                'https://localhost/items?cursor=MjAyMS0wOC0wMVQxNToyNTo0OS4zODg3MjNa',
              total_count: users,
            },
          },
        };
        resolve(items);
      }, 100);
    });
  },
  requestSummary() {
    return new Promise((resolve) => {
      setTimeout(() => {
        const summary = { data: mockUserRegistrySummary() };
        resolve(summary);
      }, 100);
    });
  },
};

export default userRegistryApi;
